import React, { useEffect } from "react";
import { ResellerHeader } from "../components/reseller/ResellerHeader";
import { ResellerHero } from "../components/reseller/ResellerHero";
import { ResellerBenefits } from "../components/reseller/ResellerBenefits";
import { ResellerPackages } from "../components/reseller/ResellerPackages";
import { ResellerSteps } from "../components/reseller/ResellerSteps";
import { ResellerFaq } from "../components/reseller/ResellerFaq";
import { ResellerCta } from "../components/reseller/ResellerCta";
import Footer from "../components/Footer";
import SupportChat from "../components/SupportChat";

export default function Reseller() {
  useEffect(() => {
    document.title = "Revenda MasterX HD – Seja um Revendedor";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-ink text-white" data-testid="reseller-page">
      <ResellerHeader />
      <main className="pb-16">
        <ResellerHero />
        <ResellerBenefits />
        <ResellerPackages />
        <ResellerSteps />
        <ResellerFaq />
        <ResellerCta />
        <Footer />
      </main>
      <SupportChat />
    </div>
  );
}
